import type { ICardPaymentMethod } from "../interfaces/payment-method";

export type CardCatalogFundingMethod = "DEBIT_CARD" | "CREDIT_CARD";

export type AddCardClassNoticeCard = Pick<
  ICardPaymentMethod,
  "paymentMethodId" | "brand" | "last4" | "fundingMethod" | "productClass"
>;

export type AddCardClassNotice =
  | {
      kind: "changed";
      fundingMethod: CardCatalogFundingMethod;
      card: AddCardClassNoticeCard;
    }
  | {
      kind: "unclassified";
      card: AddCardClassNoticeCard;
    };

export type AddCardFundingClassResult =
  | {
      kind: "classified";
      fundingMethod: CardCatalogFundingMethod;
      changed: boolean;
    }
  | { kind: "unclassified" };

export const catalogFundingMethodOf = (
  raw?: string | null
): CardCatalogFundingMethod | undefined =>
  raw === "DEBIT_CARD" || raw === "CREDIT_CARD" ? raw : undefined;

export const resolveAddCardFundingClass = (input: {
  intendedMethod?: string | null;
  fundingMethod?: string | null;
}): AddCardFundingClassResult => {
  const actual = catalogFundingMethodOf(input.fundingMethod);
  if (!actual) return { kind: "unclassified" };
  const intended = catalogFundingMethodOf(input.intendedMethod);
  return {
    kind: "classified",
    fundingMethod: actual,
    changed: intended != null && intended !== actual,
  };
};
